<template>
  <div>
    <label
      class="variation-listing-filters-variation-entry-label"
      :class="isHexGroup(group.variationDisplayType) ? 'hex' : ''"
      :style="isHexGroup(group.variationDisplayType) ? 'background:'+ entry.variationDisplayValue : ''"
    >
      <input
        class="variation-listing-filters-variation-entry-input"
        type="checkbox"
        :checked="isFilterUsed(group, entry)"
        :style="isHexGroup(group.variationDisplayType) ? 'display: none' : ''"
        @click='filteringLocationManage(group, entry)'
      >
      <a
        class="variation-listing-filters-variation-entry-link"
        :href="builtQueryString"
        :title="entryDisplayValue(group, entry)"
      >
        <span
          v-if="group.variationDisplayType !== 'hex-color'"
          class="variation-listing-filters-variation-entry-name"
        >
          {{ entryDisplayValue(group, entry, { trim: true }) }}
        </span>
        <i v-if="isHexGroup(group.variationDisplayType)"
           :class="isFilterUsed(group, entry) ? 'lni lni-checkmark' : 'lni'">
        </i>
      </a>
    </label>
  </div>
</template>

<script>

import VariationListingFiltersMixin from '../Mixins/VariationListingFiltersMixin'

export default {
  name: 'EntryFilter',
  mixins: [VariationListingFiltersMixin],
  props: {
    group: {
      variationDisplayType: '',
      variationGroupId: '',
      variationGroupName: null,
      variationGroupStep: 0,
      variationGroupDisplayPosition: 0,
      variations: []
    },
    entry: {
      variationActive: '',
      variationDisplayValue: '',
      variationId: '',
      variationName: '',
      variationOrder: ''
    }
  },
  computed: {
    builtQueryString () {
      return this.filteringManage(this.group, this.entry)
    }
  },
  methods: {
    isHexGroup (displayType) {
      return displayType === 'hex-color'
    }
  }
}
</script>
